import { configureStore } from '@reduxjs/toolkit';
import yachtsReducer from './slices/yachtsSlice';
import brandsReducer from './slices/brandsSlice';
import yachtGroupsReducer from './slices/yachtGroupsSlice';
import buildProjectsReducer from './slices/buildProjectsSlice';
import inquiriesReducer from './slices/inquiriesSlice';

const store = configureStore({
  reducer: {
    yachts: yachtsReducer,
    brands: brandsReducer,
    yachtGroups: yachtGroupsReducer,
    buildProjects: buildProjectsReducer,
    inquiries: inquiriesReducer,
  },
});

export default store;
